import { render, staticRenderFns } from "./DataTableGoldenMobile.vue?vue&type=template&id=024f78b5&scoped=true"
import script from "./DataTableGoldenMobile.vue?vue&type=script&lang=js"
export * from "./DataTableGoldenMobile.vue?vue&type=script&lang=js"
import style0 from "./DataTableGoldenMobile.vue?vue&type=style&index=0&id=024f78b5&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024f78b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('024f78b5')) {
      api.createRecord('024f78b5', component.options)
    } else {
      api.reload('024f78b5', component.options)
    }
    module.hot.accept("./DataTableGoldenMobile.vue?vue&type=template&id=024f78b5&scoped=true", function () {
      api.rerender('024f78b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tables/DataTableGoldenMobile.vue"
export default component.exports